<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-25 10:53:09
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.car_number"
                  size="mini"
                  clearable
                  placeholder="请输入车牌号查找" />
      </div>
        <div class="shaixuan-item">
            <el-select v-model="queryParam.commId" clearable filterable placeholder="请选择小区">
                <el-option v-for="item in optionList" :key="item.id" :label="item.commName" :value="item.commId" />
            </el-select>
        </div>
        <div class="shaixuan-item">
            <el-input v-model="queryParam.key"
                      size="mini"
                      clearable
                      placeholder="请输入车位号查找" />
        </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   style=" background: #1067e0;border-color: #1067e0;"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <!-- <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button> -->
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                size="mini"
                style="width: 100%; min-height: 300px">
        <el-table-column prop="id"
                         label="id"
                         width="80" />
        <el-table-column prop="car_number" label="车牌号" minWidth="120" />
        <el-table-column label="车辆图片" width="140" >
            <template slot-scope="scope">
                <el-image
                    style="width: 100px; height: 100px"
                    v-if="scope.row.car_pic"
                    :src="$adddom(scope.row.car_pic)"
                    :preview-src-list="[$adddom(scope.row.car_pic)]">
                </el-image>
            </template>
        </el-table-column>
        <el-table-column label="业主电话" width="120" >
          <template slot-scope="scope">
            <span v-if="scope.row.yezhu_phone">{{ scope.row.yezhu_phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业主" width="120" >
          <template slot-scope="scope">
            <span v-if="scope.row.yezhu_name">{{ scope.row.yezhu_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所有者" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{ scope.row.user.nickname }}</span>
            </template>
        </el-table-column>
        <el-table-column label="所有者图片" width="140" >
            <template slot-scope="scope">
                <el-image
                    v-if="scope.row.user && scope.row.user.avatar"
                    style="width: 100px; height: 100px"
                    :src="$adddom(scope.row.user.avatar)"
                    :preview-src-list="[$adddom(scope.row.user.avatar)]">
                </el-image>
            </template>
        </el-table-column>
        <el-table-column label="所有者电话" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{ scope.row.user.phone }}</span>
            </template>
        </el-table-column>
        <el-table-column label="所属小区" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.user_resource">{{ scope.row.user_resource.commName }}</span>
            </template>
        </el-table-column>
        <el-table-column label="所属资源" width="200" >
            <template slot-scope="scope">
              <span v-if="scope.row.user_resource">{{ scope.row.user_resource.resourceCode }}</span>
            </template>
        </el-table-column>
        <el-table-column prop="remark" label="审核备注" minWidth="100" />
        <el-table-column prop="updated_at" label="更新时间" width="90" />
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="220">
          <template slot-scope="scope">
            <!-- <el-button type="danger"
                       style="
                                    background: #42d885;
                                    border-color: #42d885;
                                "
                       size="mini"
                       @click="clickItem(1, scope.row)">修改</el-button> -->
            <el-button type="danger"
                       style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                       size="mini"
                       @click="clickDetail(scope.row)">详情</el-button>
            <!-- <el-button type="danger"
                       @click="remove(scope.row)"
                       size="mini">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <!-- <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <RoleAdd ref="RoleAdd"
                 @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer> -->
    <!-- 详情 -->
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDetail"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ "详情" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <ResourceDetail ref="ResourceDetail"
                 @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/car";
import city from '@/api/tianzheng/city'
import Qu from "@/api/tianzheng/Qu";
// import RoleAdd from "./QuAdd.vue";
import ResourceDetail from "./carDetail.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      queryParam: {
        car_number: '',
        page: 1,
        size: 10,
        commId:'',
        key:''
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
      showDetail:false,
      optionList:[]
    };
  },
  components: {
    Pagination,
    ResourceDetail
  },
  created () {
    this.getSelectCity()//小区下拉数据
  },
  mounted () {
    this.getList();
  },
  methods: {
    getSelectCity() {
      Qu.select({}).then(res => {
        if (res.code == 200) {
          this.optionList = res.result;
        }
      })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc:
 */
    changeStatus (val) {
      let params = {
        role_id: val.id,
        status: val.status
      };
      fetch.status(params).then(res => {
        if (res.code == 200) {
          this.getList();
        } else {
          this.getList();
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.showDetail = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
        this.showDetail = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.showDetail = false;
      if (this.$refs.RoleAdd){
        this.$refs.RoleAdd.resetForm();
      }
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.RoleAdd.initFun(obj);
      });
    },
    clickDetail(row){
      let that = this
      this.showDetail = true;
      let obj = {
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.ResourceDetail.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      fetch.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          fetch.remove({ role_id: row.id }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
